// src/hooks/useMeasure.ts
import { useEffect as useEffect2, useRef as useRef2, useState } from "react";

// src/utils/isBrowser.ts
function isBrowser() {
  return typeof window !== "undefined";
}

// src/hooks/useIsMounted.ts
import { useCallback, useEffect, useRef } from "react";
var useIsMounted = () => {
  const isMounted = useRef(false);
  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);
  return useCallback(() => isMounted.current, []);
};

// src/hooks/useMeasure.ts
var DEFAULT_RECT = {
  bottom: 0,
  height: 0,
  left: 0,
  right: 0,
  top: 0,
  width: 0,
  x: 0,
  y: 0
};
var useMeasure = ({
  onResize,
  ref
}) => {
  const _isBrowser = isBrowser();
  const isMounted = useIsMounted();
  const [rect, setRect] = useState(DEFAULT_RECT);
  const onResizeRef = useRef2(onResize);
  useEffect2(() => {
    if (!ref.current || !_isBrowser)
      return;
    const observer = new window.ResizeObserver((entries) => {
      var _a;
      const _rect = entries[0].contentRect;
      if (isMounted())
        setRect(_rect);
      (_a = onResizeRef.current) == null ? void 0 : _a.call(onResizeRef, _rect);
    });
    observer.observe(ref.current);
    return () => {
      observer.disconnect();
    };
  }, [ref, isMounted, _isBrowser]);
  return rect;
};
var useMeasure_default = useMeasure;
export {
  DEFAULT_RECT,
  useMeasure_default as default,
  useMeasure
};
//# sourceMappingURL=useMeasure.mjs.map